import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../../Containers/Config/index.js';
import { GET_LEDGER_DETAILS, GET_LEDGER_DETAILS_SUCCESS, GET_LEDGER_DETAILS_ERROR } from '../../../actions.js';
import apiCall from '../../../../apiCall.js';

function* getLedgerDetails({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const { ledgerId } = payload?.urlParams || {};

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/ledger-details/${ledgerId}`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_LEDGER_DETAILS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_LEDGER_DETAILS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_LEDGER_DETAILS_ERROR, payload: error });
  }
}

export function* watchgetLedgerDetails() {
  yield takeEvery(GET_LEDGER_DETAILS, getLedgerDetails);
}

function* getLedgerDetailsSaga() {
  yield all([fork(watchgetLedgerDetails)]);
}

export default getLedgerDetailsSaga;
